import { type AuthToken } from '@reliance/types/models/Auth';
import { type TextMessage } from '@reliance/types/models/TextMessage';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';

export const textMessage = (
  siteApi: ApiService,
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  index: (params = {}): Promise<PaginatedResponse<TextMessage>> => {
    return siteApi.get('/text-message', { params });
  },
  excelIndexUrl: (params) => {
    return siteApi.buildUrl('/text-message.xls', {
      ...params,
      token: getToken().accessToken,
    });
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/text-message.pdf', {
      ...params,
      token: getToken().accessToken,
    });
  },
  asset: {
    delete: (
      id,
      data,
    ): Promise<ApiSuccessResponse<{ id: number; message: string }>> => {
      return centralApi.delete(`/text-message/${id}/asset`, { params: data });
    },
  },
});
